<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Edit automation</h1>
        </template>

        <div v-if="loaded">
            <div class="mb-4 w-full">
                <div class="border-b border-gray-dark">
                    <p class="font-bold rounded p-2">When...</p>
                </div>
                <automation-query-maker
                    @change="syncQuery($event)"
                    :queries="query"
                ></automation-query-maker>

                <div class="border-b border-gray-dark">
                    <p class="font-bold rounded p-2">Then...</p>
                </div>

                <action-selector
                    :type="action"
                    @change="selectAction($event)"
                ></action-selector>

                <div class="mt-2">
                    <spell-maker
                        :type="action"
                        :spell="spell"
                        @change="syncSpell($event)"
                    ></spell-maker>
                    <p
                        class="text-destructive"
                        v-if="errors.spell && errors.spell.length > 0"
                    >
                        {{ errors.spell[0] }}
                    </p>
                </div>
            </div>
        </div>
        <div v-else>
            <loading />
        </div>

        <template v-slot:footer v-if="loaded">
            <progressable-button
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white font-bold"
                :loading="loading"
                state="Creating..."
                @click.native="submit"
            >
                Update
            </progressable-button>
            <button
                class="ml-2 py-2 px-4 rounded-md bg-primary-lightest"
                @click="close"
            >
                Cancel
            </button>
        </template>
    </modal-component>
</template>

<script>
import Loading from "../utilities/Loading.vue";
import ActionSelector from "./ActionSelector.vue";
import SpellMaker from "./SpellMaker.vue";

export default {
    components: { SpellMaker, ActionSelector, Loading },
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loaded: false,
            loading: false,
            errors: {},
            action: "",
            query: this.queries,
            spell: null,
        };
    },
    mounted() {
        this.getIntent();
    },
    methods: {
        getIntent() {
            return axios
                .get(`/api/intents/${this.id}`)
                .then((response) => {
                    this.action = this.prepareAction(response.data.data);

                    this.query = response.data.data.value;
                    this.spell = response.data.data.spell;

                    this.loaded = true;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        prepareAction(intent) {
            return intent.action === "spell"
                ? `spell.${intent.spell.name}`
                : intent.action;
        },
        syncQuery($event) {
            this.query = $event;
        },
        syncSpell($event) {
            this.spell = $event;
        },
        submit() {
            const action = this.action.split(".")[0];
            const payload = {
                type: "query",
                values: [this.query],
                action: action,
                spell: action === "spell" ? this.spell : null,
            };

            this.loading = true;
            this.errors = {};
            axios
                .put(`/api/intents/${this.id}`, payload)
                .then(() => {
                    this.$emit("resolve", payload);
                })
                .catch((err) => {
                    this.errors = err.response.data.errors;
                    this.loading = false;
                    console.error(err);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        selectAction(action) {
            this.action = action;
        },
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.label-joiner {
    @apply bg-primary-lighter text-primary rounded-full px-2 py-1 font-bold text-xs;
}
</style>
